import { compatibleImageProjection } from './projection';

export const VARIANTS_QUERY = /* groq */ `
*[_type == "productVariantSection"][0]{
  heading,
  buttons[]{
    label,
    link{ href, newTab },
    style
  },
  productVariantItems[]{
    name,
    headline,
    description,
    variantValue,
    ${compatibleImageProjection({
      alias: 'defaultImage',
      imageField: 'defaultImage->image',
      bynderField: 'defaultImage->bynderImage',
    })},
    image{asset->{url}, alt},
    campaignLink{href,newTab},
    productVariant->{
      name,
      image[]{asset->{url}},
      options[]->{ value, attribute->{name} }
    }
  }
}`;
